import React, { useEffect, useState, useContext } from 'react';
import { useApi } from '../../Hooks/useApi'
import { useParams, useNavigate } from "react-router-dom";
import SiteSetting from '../../Context/SiteSetting';
import './Listing.scss';
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';

const Listing = (props) => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { t, i18n } = useTranslation();

  const api = useApi();
  const { account } = useParams();
  const context = useContext(SiteSetting);
  const [events] = useState(context.setting.events);
  const [pageType] = useState(props.type);
  let navigate = useNavigate();

  document.documentElement.setAttribute('type',props.type);

  const handleForm = (data) => {
    if(pageType === 'embed') {
      window.open(`/${account}/event/${data.event}`);
    } else {
      return navigate(`/${account}/event/${data.event}`);
    }
  }

  return (
    <div className="container listing">
      <div className='wrapper-form box'>
        <div className='title'>{t('When will you be joining us')}</div>

        <form onSubmit={handleSubmit(handleForm)} noValidate>
          <div className='wrapper-select'>
            <select {...register('event')}>
              {events && <>
                  {events.map((item, i) => {
                    return <option key={i} value={item.id}>{item.name[i18n.language]} ({item.datetime})</option>
                  })}
              </>}
            </select>
          </div>
          <button type='submit'>{t('register')}</button>
        </form>
        <div className='note'>{t('Registration is quick and easy in a few simple steps')}</div>
      </div>
    </div>
  );
};

export default Listing;
